import React from "react";

import './_events.scss'
import {Breadcrumb, BreadcrumbItem, Column, Grid, Tile} from "@carbon/react";
import {Link} from "react-router-dom";
import EventsTable from "../../components/EventsTable";

const Events = () => {
  return (
    <Grid fullWidth className="alarms-page">
      <Column lg={16} md={8} sm={4} >
        <Grid className="page-banner">
          <Column lg={16} md={4} sm={4}>
            <Breadcrumb noTrailingSlash aria-label="Page navigation">
              <BreadcrumbItem>
                <Link to='/'>Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                Sistema
              </BreadcrumbItem>
              <BreadcrumbItem>
                Eventi
              </BreadcrumbItem>
            </Breadcrumb>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <h1 className="page-heading">
              Eventi
            </h1>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4} className="customers-page__r1">
            <Tile>
              <EventsTable />
            </Tile>
          </Column>
        </Grid>
      </Column>
    </Grid>
  )
}

export default Events